import script from "./AudienceIntegrationSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceIntegrationSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceIntegrationSkeleton.vue?vue&type=style&index=0&id=20b9d58a&lang=scss"

const __exports__ = script;

export default __exports__